import { createMuiTheme } from '@material-ui/core/styles'
import { SCHOOL_LEIDERCHAP_SUBDOMAIN_NAME } from '../constants'

const baseMUITheme = createMuiTheme()

const primaryMain = '#272B55'
const secondaryMain = '#00C5CD'

export const theme = subdomain =>
  createMuiTheme({
    components:{
      CustomForms:{
        question: {
          display: 'block',
          padding: baseMUITheme.spacing(2, 0, 1, 0),
          fontWeight: 'bold',
          fontSize: baseMUITheme.spacing(2),
        },
      },
    },
    palette: {
      primary: {
        main: subdomain!== SCHOOL_LEIDERCHAP_SUBDOMAIN_NAME ? primaryMain: secondaryMain,
      },
      secondary: {
        main: subdomain!== SCHOOL_LEIDERCHAP_SUBDOMAIN_NAME ? secondaryMain: primaryMain,
      },
    },
    typography: {
      fontFamily: `"Montserrat", sans-serif`,
    },
    overrides: {
      MuiTabs: {
        indicator: {
          backgroundColor: primaryMain,
        },
        flexContainer: {
          padding: '1px 10px',
          display: 'flex',
          width: '100%',
          flexWrap: 'nowrap',
          flexDirection: 'row',
          marginRight: 'auto',
          justifyContent: 'flex-end',
        },
      },
      MuiTab: {
        root: {
          background: 'paper',
        },
      },
      MuiFormControl: {
        root: {
          marginBottom: baseMUITheme.spacing(2),
        },
      },
    },
  })

export default theme
